module.exports = __webpack_public_path__ + "static/img/qw_mob_01.52456918.png";